// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from "react";
import "./DeliveryCard.scss";
import DeliveryDetails from "../../DeliveryDetails/DeliveryDetails";

export default function DeliveryCard({cardData, payload}) {
    return (
        <div className="delivery-card-body">
            <DeliveryDetails
                deliveryId={payload.deliveryId}
                deliveriesSettings={payload.deliveriesSettings}
            />
        </div>
    );
}